import { BodySmall, FlexColMd } from '../Elements';
import styled from 'styled-components';
import { sizes } from 'theme';
import strings from '../../strings/strings.json';
import Button from 'components/buttons/Button';

type EmptyTableContentProps = {
    icon?: JSX.Element;
    title?: string;
    description?: string;
    buttonTitle?: string;
    buttonAria?: string;
    buttonIcon?: JSX.Element;
    buttonOnClick?: () => void;
};

export function EmptyTableContent({
    icon,
    title,
    description,
    buttonTitle,
    buttonAria,
    buttonIcon,
    buttonOnClick,
}: EmptyTableContentProps): JSX.Element {
    return (
        <EmptyTableContentContainer>
            {icon && icon}
            {title && <BodySmall $bold>{title ?? strings.emptyTableContent.title}</BodySmall>}
            {description && <BodySmall>{description}</BodySmall>}
            {buttonTitle && buttonAria && buttonOnClick && (
                <Button title={buttonTitle} aria={buttonAria} icon={buttonIcon} onClick={buttonOnClick} />
            )}
        </EmptyTableContentContainer>
    );
}

const EmptyTableContentContainer = styled(FlexColMd)`
    align-items: center;
    margin: ${sizes.spacingRg};
`;
